import * as React from 'react'

import * as Sentry from '@sentry/browser'
import verifiedIcon from 'assets/images/verified.svg'
import classNames from 'classnames/bind'
import type { $Keys } from 'utility-types'

import { useNavigation } from 'modules/core/hooks/useNavigation'

import configurator from 'modules/app_store/lib/SubscriptionAddonConfigurator'
import ICONS from 'modules/app_store/lib/appIconAssets'
import subscriptionAddons from 'modules/billing/store/collections/subscriptionAddons'

import styles from './index.module.scss'

const cx = classNames.bind(styles)

const Sizes = {
  40: '40',
  // eslint-disable-line quote-props
  '64': '64', // eslint-disable-line quote-props
}
type Size = $Keys<typeof Sizes>
interface Props {
  id: string
  size?: Size
  isVerified?: boolean
}

const AppIcon = ({ id, size = '64', isVerified = true }: Props) => {
  const { navigation } = useNavigation()

  const subscriptionAddon = subscriptionAddons.find({
    id,
  })

  if (!subscriptionAddon) {
    Sentry.captureException(`subscriptionAddon not found with provided id: ${id}`)

    return null
  }

  const config = configurator.getSubscriptionAddonConfig(subscriptionAddon, navigation)
  const { backgroundColor = 'white' } = config

  return (
    <div
      className={cx('wrap', `size${size}`)}
      style={{
        backgroundColor,
      }}
    >
      <img src={ICONS[id]} width={24} />
      {isVerified && <img className={styles.verified} src={verifiedIcon} />}
    </div>
  )
}

export default AppIcon
